<template>
  <div></div>
</template>
<script>

import { mapGetters } from 'vuex';
import axios from "axios"

export default {
  props: ['sid'],
  data() {
    return {
      orderId: "",
      response: "",
    }
  },
  computed: {
    ...mapGetters("persist", [
      "isOrderComplete",
      "getFinalFormData",
      "getProduct",
      "getVerificationData"
    ]),
  },
  methods: {
    requestOrder() {
      axios({
          method: "get",
          url: process.env.VUE_APP_API_BASE_URL + "requestorder/" + this.sid,
      })
      .then(res => {
        this.response = res.data
        this.acknowledgeOrder();
      })
      /* eslint-disable no-unused-vars */
      .catch(res => {
        this.response = res
      })
    },
    acknowledgeOrder() {
      axios({
          method: "get",
          url: process.env.VUE_APP_API_BASE_URL + "acknowledgeorder/" + this.sid,
      })
      .then(res => {
        this.response = res.data
      })
      /* eslint-disable no-unused-vars */
      .catch(res => {
        this.response = res
      })
    }
  },
  mounted() {    
    this.requestOrder();    
  }
}
</script>